import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const style = () => ({
    root: {
        marginBottom: 12,
    }
});

const TextOnlyFormField = (props) => {
    return (
        <div className={props.classes.root}>
            <Typography variant="body1">
                {
                    props.label ? (
                        `${props.label}:`
                    ) : (
                        ''
                    )
                }
            </Typography>
            <Typography variant={props.valueVariant}>
                {
                    props.link ? (
                        <a href={props.link} target="_blank">
                            {props.value}
                        </a>
                    ) : (
                        props.value
                    )
                }
            </Typography>
        </div>
    );
};

TextOnlyFormField.propTypes = {
    classes: PropTypes.shape({
        root: PropTypes.string.isRequired,
    }).isRequired,
    label: PropTypes.string,
    value: PropTypes.string,
    valueVariant: PropTypes.string,
    link: PropTypes.string,
};

TextOnlyFormField.defaultProps = {
    label: '',
    value: '',
    valueFontVariant: 'body1',
};

export default withStyles(style)(TextOnlyFormField);
